import React, {FC} from 'react';
import {SkeletonLoader} from '../Loaders';

export const Loader: FC = () => (
	<div className={'grid gap-4'} role={'note'} aria-label={'loader'}>
		<div className={'flex justify-between h-6'}>
			<SkeletonLoader width={300} />
			<SkeletonLoader width={47} />
		</div>
		<div className={'flex justify-between h-6'}>
			<SkeletonLoader width={360} />
			<SkeletonLoader width={44} />
		</div>
		<div className={'flex justify-between h-6'}>
			<SkeletonLoader width={320} />
			<SkeletonLoader width={37} />
		</div>
		<div className={'flex justify-between h-6'}>
			<SkeletonLoader width={360} />
			<SkeletonLoader width={47} />
		</div>
	</div>
);
